
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { MessageSquare } from "lucide-react";

interface CopilotUsageMeterProps {
  usedCount: number;
  limit: number;
  percentUsed: number;
}

const CopilotUsageMeter = ({ usedCount, limit, percentUsed }: CopilotUsageMeterProps) => {
  const getTextColor = () => {
    if (percentUsed >= 90) return "text-destructive";
    if (percentUsed >= 70) return "text-orange-600";
    return "text-muted-foreground";
  };

  const getProgressColor = () => {
    if (percentUsed >= 90) return "bg-destructive";
    if (percentUsed >= 70) return "bg-orange-500";
    return "bg-primary";
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4 text-blue-500" />
          <span className="text-sm font-medium">Product Copilot Messages</span>
        </div>
        <Badge variant="outline" className={getTextColor()}>
          {usedCount} / {limit === 999999 ? '∞' : limit}
        </Badge>
      </div>
      
      {limit !== 999999 && (
        <div className="space-y-1">
          <div className="relative">
            <Progress 
              value={percentUsed} 
              className="h-2"
            />
            <div 
              className={`absolute top-0 left-0 h-2 rounded-full transition-all ${getProgressColor()}`}
              style={{ width: `${Math.min(percentUsed, 100)}%` }}
            />
          </div>
          <p className={`text-xs ${getTextColor()}`}>
            {percentUsed}% used this month
            {percentUsed >= 90 && " - Consider upgrading your plan"}
          </p>
        </div>
      )}
    </div>
  );
};

export default CopilotUsageMeter;
